import type { LocaleLanguage } from '@/lib/locale-context';
import { Consultation } from '@/sections/forms/multistep-form/types';
import { buildStrapiUrl } from '../utils/strapi-url';
import { fetchWithRetry } from './fetch-with-retry';

export const fetchConsultationsFromStrapi = async (
  locale: LocaleLanguage = 'de',
): Promise<Consultation[]> => {
  const base = process.env.NEXT_PUBLIC_STRAPI_URL;
  if (!base) return [];

  const params = new URLSearchParams({
    locale,
  });

  const res = await fetchWithRetry(
    buildStrapiUrl('/api/web/consultations', params),
    {
      cache: 'no-store',
    },
  );

  // Degrade to an empty list instead of letting json() throw on an upstream
  // HTML error page — the multistep form treats it as "no options available".
  if (!res.ok) {
    console.error(`Failed to fetch consultations (${res.status})`);
    return [];
  }

  const json = await res.json();
  return (json?.data ?? []) as Consultation[];
};
